export const MATCH_SCHEDULE_COUNT = 3;
